import authGraphQLRequest from "utils/authGraphQLRequest";
import moment from "moment";

let prevSearchText = "";

export const getPayout = ({ page, per_page, searchTexts }: any): Promise<any> => {
  return new Promise((resolve, reject) => {

    let currentPage = page;

    if (searchTexts && !prevSearchText) {
      currentPage = 1; 
    }
    prevSearchText = searchTexts || "";

    let queryString = `{ 
      allPayout(page: ${currentPage}, per_page: ${per_page}, searchTexts: "${searchTexts}") {
        payouts{
            id
            organizationId   
            clientId    
            batchId    
            clientName
            type 
            gatewayId
            gatewayName
            createdAt
            updatedAt
            totalTransactions
            transactions {
                createdAt
                currency
                chain
                address
                amount
                payerId
                referenceNo
                status
                message
                gatewayResponse
                paymentHistory
            }
            totalAmount
        }
      }
    }`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_all_payout'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

let prevSearchTextRegular = "";

export const getRegularPayout = ({ page, per_page, searchTexts,filter }: any): Promise<any> => {
  return new Promise((resolve, reject) => {

    let currentPage = page;

    if (searchTexts && !prevSearchTextRegular) {
      currentPage = 1; 
    }
    prevSearchTextRegular = searchTexts || "";

    const clients =
      filter?.clients?.length > 0
        ? `[${filter.clients.map((c: string) => `"${c}"`).join(",")}]`
        : "";

    const gateways =
      filter?.gateways?.length > 0
        ? `[${filter.gateways.map((g: string) => `"${g}"`).join(",")}]`
        : "";

    const start_date = filter?.dates?.[0]
        ? moment(filter.dates[0]).format("YYYY-MM-DD")
        : "";

    const end_date = filter?.dates?.[1]
        ? moment(filter.dates[1]).format("YYYY-MM-DD")
        : "";

    let queryString = `{ 
      allRegularPayout(
        page: ${currentPage}, 
        per_page: ${per_page}, 
        searchTexts: "${searchTexts}"
        ${clients ? `, clients: ${clients}` : ""}
        ${gateways ? `, gateways: ${gateways}` : ""}
        ${start_date ? `, start_date: "${moment(start_date).format("YYYY-MM-DD")}"` : ""}
        ${end_date ? `, end_date: "${moment(end_date).format("YYYY-MM-DD")}"` : ""}
      ) {
        payouts{
          id
          organizationId   
          clientId    
          batchId    
          clientName
          gatewayId
          gatewayName
          createdAt
          updatedAt
          totalTransactions
          transactions {
              createdAt
              currency
              amount
              status
              message
              transactionId
              internalId
              gatewayResponse
              paymentHistory
          }
          totalAmount
      }
      }
    }`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_all_regular_payout'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getPayin = ({ page, per_page, searchTexts,filter }: any): Promise<any> => {
  return new Promise((resolve, reject) => {

    let currentPage = page;

    if (searchTexts && !prevSearchText) {
      currentPage = 1; 
    }
    prevSearchText = searchTexts || "";

    const clients =
      filter?.clients?.length > 0
        ? `[${filter.clients.map((c: string) => `"${c}"`).join(",")}]`
        : "";

    const gateways =
      filter?.gateways?.length > 0
        ? `[${filter.gateways.map((g: string) => `"${g}"`).join(",")}]`
        : "";

    const start_date = filter?.dates?.[0]
        ? moment(filter.dates[0]).format("YYYY-MM-DD")
        : "";

    const end_date = filter?.dates?.[1]
        ? moment(filter.dates[1]).format("YYYY-MM-DD")
        : "";

    let queryString = `{ 
      allPayin(
        page: ${currentPage}, 
        per_page: ${per_page}, 
        searchTexts: "${searchTexts}"
        ${clients ? `, clients: ${clients}` : ""}
        ${gateways ? `, gateways: ${gateways}` : ""}
        ${start_date ? `, start_date: "${moment(start_date).format("YYYY-MM-DD")}"` : ""}
        ${end_date ? `, end_date: "${moment(end_date).format("YYYY-MM-DD")}"` : ""}
      ) {
        payins{
            id
            organizationId   
            clientId    
            batchId    
            clientName
            gatewayId
            gatewayName
            createdAt
            updatedAt
            totalTransactions
            transactions {
                createdAt
                customerId
                invoiceCurrency
                invoiceChain
                invoiceAmount
                paymentCurrency
                paymentChain
                paymentAmount
                checkoutLink
                quoteId
                status
                message
            }
        }
      }
    }`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_all_payin'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createBatchPayout = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation {
            createBatchPayout(
                client_id: "${data.client_id}"
                organization_id: "${data.organization_id}"
                type: "${data.type}"
                file: "${data.file}"
                gateway:"${data.gateway}"
                currency : "${data.currency}"
                total_fees : "${data.total_fees}"
            ) {
                status
                message
            }
        }`;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_create_batch_payout'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}

export const createRegularBatchPayout = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation {
            createRegularBatchPayout(
                client_id: "${data.client_id}"
                organization_id: "${data.organization_id}"
                file: "${data.file}"
                gateway:"${data.gateway}"
                settlement_currency : "${data.settlement_currency}"
                total_fees : "${data.total_fees}"
                batch_type : "${data.batch_type}"
            ) {
                status
                message
            }
        }`;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_create_regular_batch_payout'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}

export const createBatchPayin = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation {
            createBatchPayin(
                client_id: "${data.client_id}"
                organization_id: "${data.organization_id}"
                file: "${data.file}"
                gateway:"${data.gateway}"
            ) {
                status
                message
            }
        }`;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_create_batch_payin'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}